import { useMutation } from '@tanstack/react-query';
import PropTypes from 'prop-types';
import React from 'react';
import AsyncSelect from 'react-select/async';
import { useTranslation } from 'react-i18next';
import { authHeaders } from '../../actions';
import Routes from '../../utils/routes.js.erb';

const CardSelector = React.memo(({
  value,
  onChange,
  isDisabled,
  onErrorMessage,
  className = '',
}) => {
  const { t } = useTranslation();
  const searchTimeoutRef = React.useRef(null);

  const loadOptions = (inputValue, callback) => {
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (!inputValue.trim()) {
      callback([]);
      return;
    }

    searchTimeoutRef.current = setTimeout(() => {
      mutation.mutate(inputValue, {
        onSuccess: (data) => {
          callback(data);
        },
        onError: (error) => {
          onErrorMessage(t('errors.generic'));
          console.error('Error fetching cards:', error);
          callback([]);
        }
      });
    }, 500);
  };

  const mutation = useMutation({
    mutationFn: async (searchQuery) => {
      const response = await fetch(
        Routes.api_dashboard_communication_filters_for_cards_path({ q: searchQuery }),
        {
          method: 'GET',
          headers: authHeaders()
        }
      );

      if (!response.ok) {
        throw new Error('Error fetching cards');
      }

      return response.json();
    }
  });

  return(
    <AsyncSelect
      name='sp-card-select'
      className={`o-communication__select ${className}`}
      isMulti={true}
      value={value}
      loadOptions={loadOptions}
      placeholder={t('communication.cardSelectorPlaceholder')}
      noOptionsMessage={() => t('communication.noOptions')}
      onChange={onChange}
      isDisabled={isDisabled}
      cacheOptions={true}
      defaultOptions={false}
      menuPlacement="top"
    />
  )
});

CardSelector.propTypes = {
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  onErrorMessage: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default CardSelector;
